import { render, staticRenderFns } from "./MobileNavbar.vue?vue&type=template&id=52482810&"
import script from "./MobileNavbar.vue?vue&type=script&lang=js&"
export * from "./MobileNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports